// extracted by mini-css-extract-plugin
module.exports = {"paperContainer":"Reports_paperContainer__3cE-C","title":"Reports_title__3aJW2","mainContainer":"Reports_mainContainer__3fyKo"};